import request from '@/utils/request'
let BASEROOT = '/visitor/v1'
let BASEROOT2 = '/visitor/v2'

// 展商 展商统计
export function exhibitorStatistic(query) {
    return request({
        url: BASEROOT + '/statistic/exhibitor',
        method: 'post',
        data: query
    })
}

// 展商 展商统计列表 
export function exhibitorStatisticList(query) {
    return request({
        url: BASEROOT + '/statistic/exhibitor/list',
        method: 'post',
        data: query
    })
}

// 展商 展商统计列表 导出 
export function exhibitorStatisticListExport(query) {
    if (query === false) {
        return BASEROOT + '/statistic/exhibitor/list/export'
    } else {
        return request({
            url: BASEROOT + '/statistic/exhibitor/list/export',
            method: 'post',
            data: query
        })
    }
}

// 展商 展品统计
export function productStatistic(query) {
    return request({
        url: BASEROOT + '/statistic/product',
        method: 'post',
        data: query
    })
}

// 展商 展品统计列表
export function productStatisticList(query) {
    return request({
        url: BASEROOT + '/statistic/product/list',
        method: 'post',
        data: query
    })
}

// 展商 展品统计列表 导出
export function productStatisticListExport(query) {
    if (query === false) {
        return BASEROOT + '/statistic/product/list/export'
    } else {
        return request({
            url: BASEROOT + '/statistic/product/list/export',
            method: 'post',
            data: query
        })
    }
}

// 展商 展品统计列表详情
export function productStatisticInfo(query) {
    return request({
        url: BASEROOT + '/statistic/product/info',
        method: 'post',
        data: query
    })
}

// 展商 展品统计列表详情 导出
export function productStatisticInfoExport(query) {
    if (query === false) {
        return BASEROOT + '/statistic/product/info/export'
    } else {
        return request({
            url: BASEROOT + '/statistic/product/info/export',
            method: 'post',
            data: query
        })
    }
}

// 展商 商脉圈统计
export function commercialStatistic(query) {
    return request({
        url: BASEROOT + '/statistic/commercial',
        method: 'post',
        data: query
    })
}

// 展商 商脉圈统计列表
export function commercialStatisticList(query) {
    return request({
        url: BASEROOT + '/statistic/commercial/list',
        method: 'post',
        data: query
    })
}

// 展商 商脉圈统计列表 导出
export function commercialStatisticListExport(query) {
    if (query === false) {
        return BASEROOT + '/statistic/commercial/list/export'
    } else {
        return request({
            url: BASEROOT + '/statistic/commercial/list/export',
            method: 'post',
            data: query
        })
    }
}

// 展商 商脉圈统计列表详情
export function commercialStatisticInfo(query) {
    return request({
        url: BASEROOT + '/statistic/commercial/info',
        method: 'post',
        data: query
    })
}

// 展商 商脉圈统计列表详情 导出
export function commercialStatisticInfoExport(query) {
    if (query === false) {
        return BASEROOT + '/statistic/commercial/info/export'
    } else {
        return request({
            url: BASEROOT + '/statistic/commercial/info/export',
            method: 'post',
            data: query
        })
    }
}

// 展商 邀约统计
export function inviteStatistic(query) {
    return request({
        url: BASEROOT + '/statistic/invite',
        method: 'post',
        data: query
    })
}

// 展商 邀约统计列表
export function inviteStatisticList(query) {
    return request({
        url: BASEROOT + '/statistic/invite/list',
        method: 'post',
        data: query
    })
}

// 展商 邀约统计列表 导出
export function inviteStatisticListExport(query) {
    if (query === false) {
        return BASEROOT + '/statistic/invite/list/export'
    } else {
        return request({
            url: BASEROOT + '/statistic/invite/list/export',
            method: 'post',
            data: query
        })
    }
}

// 展商 邀约统计列表详情
export function inviteStatisticInfo(query) {
    return request({
        url: BASEROOT + '/statistic/invite/info',
        method: 'post',
        data: query
    })
}

// 展商 邀约统计列表详情 导出
export function inviteStatisticInfoExport(query) {
    if (query === false) {
        return BASEROOT + '/statistic/invite/info/export'
    } else {
        return request({
            url: BASEROOT + '/statistic/invite/info/export',
            method: 'post',
            data: query
        })
    }
}

// 消息联查 （获取IM账号）
export function getConnectAccount(query) {
    return request({
        url: BASEROOT + '/statistic/connect',
        method: 'post',
        data: query
    })
}

// 客商 收藏展商/展品数量
export function collectionCountForVisitor(query) {
    return request({
        url: BASEROOT2 + '/visitorStatistics/collectionCountForVisitor',
        method: 'post',
        data: query
    })
}

// 客商 收藏展商列表
export function collectionExhibitor(query) {
    return request({
        url: BASEROOT2 + '/visitorStatistics/collectionExhibitor',
        method: 'post',
        data: query
    })
}

// 客商 收藏展展品列表
export function collectionProduct(query) {
    return request({
        url: BASEROOT2 + '/visitorStatistics/collectionProduct',
        method: 'post',
        data: query
    })
}

// 客商 浏览展商数和展品数
export function trailCountForVisitor(query) {
    return request({
        url: BASEROOT2 + '/visitorStatistics/trailCountForVisitor',
        method: 'post',
        data: query
    })
}

// 客商 浏览展商列表
export function trailExhibitor(query) {
    return request({
        url: BASEROOT2 + '/visitorStatistics/trailExhibitor',
        method: 'post',
        data: query
    })
}

// 客商 浏览展品列表
export function trailProduct(query) {
    return request({
        url: BASEROOT2 + '/visitorStatistics/trailProduct',
        method: 'post',
        data: query
    })
}

// 客商 邀约展商数量
export function inviteRecordCount(query) {
    return request({
        url: BASEROOT2 + '/visitorStatistics/inviteRecordCount',
        method: 'post',
        data: query
    })
}

// 客商 邀约展商列表
export function inviteRecordExhibitor(query) {
    return request({
        url: BASEROOT2 + '/visitorStatistics/inviteRecordExhibitor',
        method: 'post',
        data: query
    })
}

// 导出 客商收藏展品列表
export function collectionProductForVisitorExport(query) {
    return request({
        url: BASEROOT2 + '/visitorStatistics/collectionProductForVisitorExport',
        method: 'post',
        data: query
    })
}

// 导出 客商收藏展商列表
export function collectionExhibitorExport(query) {
    return request({
        url: BASEROOT2 + '/visitorStatistics/collectionExhibitorExport',
        method: 'post',
        data: query
    })
}

// 导出 客商浏览展品列表
export function trailProductExport(query) {
    return request({
        url: BASEROOT2 + '/visitorStatistics/trailProductExport',
        method: 'post',
        data: query
    })
}

// 导出 客商浏览展商列表
export function trailExhibitorExport(query) {
    return request({
        url: BASEROOT2 + '/visitorStatistics/trailExhibitorExport',
        method: 'post',
        data: query
    })
}

// 导出 客商邀约展商列表
export function inviteRecordExhibitorExport(query) {
    return request({
        url: BASEROOT2 + '/visitorStatistics/inviteRecordExhibitorExport',
        method: 'post',
        data: query
    })
}


// 客商 商脉圈总量
export function collectionCommercialNumsForVisitor(query) {
    return request({
        url: BASEROOT2 + '/visitorStatistics/collectionCommercialNumsForVisitor',
        method: 'post',
        data: query
    })
}

// 客商 商脉圈总量列表(商脉圈详情统计)
export function collectionCommercialForVisitor(query) {
    return request({
        url: BASEROOT2 + '/visitorStatistics/collectionCommercialForVisitor',
        method: 'post',
        data: query
    })
}

// 客商 商脉圈总量列表导出(商脉圈详情导出)
export function collectionCommercialForVisitorExport(query) {
    return request({
        url: BASEROOT2 + '/visitorStatistics/collectionCommercialForVisitorExport',
        method: 'post',
        data: query
    })
}

// 客商 展商评论总数量
export function collectionCommercialCommentNumsForVisitor(query) {
    return request({
        url: BASEROOT2 + '/visitorStatistics/collectionCommercialCommentNumsForVisitor',
        method: 'post',
        data: query
    })
}

// 客商 展商评论总数量列表(展商评论详情总量)
export function collectionCommercialCommentForVisitor(query) {
    return request({
        url: BASEROOT2 + '/visitorStatistics/collectionCommercialCommentForVisitor',
        method: 'post',
        data: query
    })
}

// 客商 展商评论总数量列表导出(展商评论详情总量导出)
export function collectionCommercialCommentForVisitorExport(query) {
    return request({
        url: BASEROOT2 + '/visitorStatistics/collectionCommercialCommentForVisitorExport',
        method: 'post',
        data: query
    })
}

// 客商 评论的展商明细
export function getExhibitorInfoByCommercialComment(query) {
    return request({
        url: BASEROOT2 + '/visitorStatistics/getExhibitorInfoByCommercialComment',
        method: 'post',
        data: query
    })
}

// 客商 评论的展商明细导出
export function getExhibitorInfoByCommercialCommentExport(query) {
    return request({
        url: BASEROOT2 + '/visitorStatistics/getExhibitorInfoByCommercialCommentExport',
        method: 'post',
        data: query
    })
}

// 客商 展商点赞总数量
export function collectionCommercialLikeNumsForVisitor(query) {
    return request({
        url: BASEROOT2 + '/visitorStatistics/collectionCommercialLikeNumsForVisitor',
        method: 'post',
        data: query
    })
}

// 客商 展商点赞总数量列表(展商点赞详情)
export function collectionCommercialLikeForVisitor(query) {
    return request({
        url: BASEROOT2 + '/visitorStatistics/collectionCommercialLikeForVisitor',
        method: 'post',
        data: query
    })
}

// 客商 展商点赞总数量列表导出(展商点赞详情导出)
export function collectionCommercialLikeForVisitorExport(query) {
    return request({
        url: BASEROOT2 + '/visitorStatistics/collectionCommercialLikeForVisitorExport',
        method: 'post',
        data: query
    })
}

// 客商 点赞的展商明细
export function getExhibitorInfoByLikeComment(query) {
    return request({
        url: BASEROOT2 + '/visitorStatistics/getExhibitorInfoByLikeComment',
        method: 'post',
        data: query
    })
}

// 客商 评论的展商明细导出
export function getExhibitorInfoByLikeCommentExport(query) {
    return request({
        url: BASEROOT2 + '/visitorStatistics/getExhibitorInfoByLikeCommentExport',
        method: 'post',
        data: query
    })
}